import React from "react";
import Div100vh from "react-div-100vh";

import ErrorImg from "@/assets/images/error-screen.svg";

export default function ErrorScreen() {
  return (
    <Div100vh className="flex flex-col justify-between py-5 px-4">
      <img src={ErrorImg} alt="error-image" className="scale-50" />
      <div className="flex flex-col">
        <span className="font-semibold text-2xl text-orange-500 mb-5">
          Sorry...🫠
        </span>
        <span className="text-base">This is taking unusually long.</span>
        <span className="font-base font-medium">Let us get back shortly!</span>
      </div>
      <div className="flex flex-col items-center justify-center">
        <button
          type="button"
          className="flex text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-700 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 w-36 hover:icon-white items-center justify-center"
        >
          Try Again
        </button>
      </div>
    </Div100vh>
  );
}
